import React, { useEffect, useState } from 'react'
import CardContainer from './CardContainer'
import SimpleSpinner from '../components/loader'
import "./dashboard.css"
import TenantsRetentionOverview from './TenantsRetentionOverview'
import { GetImages } from '../utils/GetImages'
import CategoryDistribution from './CategoryDistribution'
import { useAnalyticsHook } from '../hooks/useAnalyticsHook'
import { AnalyticsService, DateFilterTypesEnum, PaidFlowTypesEnum, UserDashboardService } from '@propertelligent/client-api'
import { UserLoginData } from '../components/common/charts/Enums'
import IncomeExpense from './IncomeExpense'
import apiHelper from '../utils/apiHelper'
import { useNavigate } from 'react-router'
import { URLS } from '../constants/constants'
import { TenantStatusesEnum } from '../components/common/Enum'
import ExpenseDistributionDashboard from '../dashboard/ExpenseDistributionDashboard'
import ExpenseDistribution from '../newComponents/charts/expense-distribution/expense-distribution'
import DateHelper from '../utils/DateHelper'
import RevenueOverview from './RevenueOverview'
import { convertENUMtoJSONArray } from '../utils/helper'
import DonutChart from '../newComponents/charts/revenue-overview/revenue-overview'
import BluePayableIcon from "../assets/Payment-Icon.svg";


const Dashboard = () => {
    const [loadingStates, setLoadingStates] = useState({
        topSectionLoading: true,
        revenueLoading: true,
        cashFlowLoading: true,
        expanseDistrubutionLoading: true,
        vacancyRateLoading: true,
        performanceOverviewLoading: true,
    });
    const [loading, setLoading] = useState(false);
    const [leaseingData, setLeaseingData] = useState<any>()
    const [maintainenceData, setMaintainenceData] = useState<any>()
    const [paymentsData, setPaymentsData] = useState<any>()
    const [categoryData, setCategoryData] = useState([])
    const [expenseLoading, setExpenseLoading] = useState(false);
    const [rev_monthValue, setRev_MonthValue] = useState<any>("Last 12 Month");
    const [cat_monthValue, setCat_MonthValue] = useState<any>("Last 12 Month");
    const [incomeExpense_monthValue, setincomeExpense_MonthValue] = useState<any>(DateFilterTypesEnum.Last3Months);
    const [leasingLoading, setLeasingLoading] = useState(true);
    const [maintenanceLoading, setMaintenanceLoading] = useState(true);
    const [paymentsLoading, setPaymentsLoading] = useState(true);
    const [retentionLoading, setRetentionLoading] = useState(true);
    const [retentionData, setRetentionData] = useState<any>(null);
    const orgId = sessionStorage.getItem(UserLoginData.organization_id);
    const userinfo = sessionStorage.getItem(UserLoginData.user_name);
    const navigate = useNavigate()

     const timeRangeToEnumMap = (range: string): number => {
        const map: Record<string, number> = {
            "This Month": DateFilterTypesEnum.MonthToDate,
            "Last 3 Month": DateFilterTypesEnum.Last3Months,
            "Last 6 Month": DateFilterTypesEnum.Last6Months,
            "Last 12 Month": DateFilterTypesEnum.Last12Months,
           };
        return map[range] ?? DateFilterTypesEnum.MonthToDate;
      };

    const getLeasingData = () => {
        setLeasingLoading(true);
        apiHelper(UserDashboardService.getApiUserDashboardLeasing, { showNotification: false }, orgId)
            .then((res) => {
                if (res?.data?.success) {
                    setLeaseingData(res?.data?.success)
                }
                setLeasingLoading(false);
            }).catch((err) => { setLeasingLoading(false); })
    }

    const getMaintenanceData = () => {
        setMaintenanceLoading(true);
        apiHelper(UserDashboardService.getApiUserDashboardMaintenance, { showNotification: false }, orgId)
            .then((res) => {
                if (res?.data?.success) {
                    setMaintainenceData(res?.data?.success)
                }
                setMaintenanceLoading(false);
            }).catch((err) => { setMaintenanceLoading(false); })
    }

    const getPaymentsData = () => {
        setPaymentsLoading(true);
        apiHelper(UserDashboardService.getApiUserDashboardPayments, { showNotification: false }, orgId)
            .then((res) => {
                if (res?.data?.success) {
                    setPaymentsData(res?.data?.success)
                }
                setPaymentsLoading(false);
            }).catch((err) => { setPaymentsLoading(false); })
    }

    useEffect(() => {
        getLeasingData()
        getMaintenanceData()
        getPaymentsData()
    }, [])

    const leasing = [
        {
            id: 0,
            heading: leaseingData?.prospectTenants || 0,
            sub_Data: "No of Prospect Tenant",
            image: GetImages.blueUser,
            onclick: () => navigate(URLS.TENANTS + `?selectedOption=${TenantStatusesEnum.Prospect}`)

        },
        {
            id: 1,
            heading: leaseingData?.activeTenants || 0,
            sub_Data: "No of Active Tenant",
            image: GetImages.blueUser,
            onclick: () => navigate(URLS.TENANTS + `?selectedOption=${TenantStatusesEnum.Current}`)

        },
        {
            id: 2,
            heading: leaseingData?.leaseExpiringSoonTenants || 0,
            sub_Data: "Lease Expiring soon",
            image: GetImages.Recepient,
            onclick: () => navigate(URLS.TENANTS + `?selectedOption=${TenantStatusesEnum.Current}&filterKey=Lease Expiring Soon&filterLabel=Lease Expiring Soon`)

        },
        {
            id: 3,
            heading: leaseingData?.movingOutTenants || 0,
            sub_Data: "Moving Out Tenants",
            image: GetImages.NoSignal,
            onclick: () => navigate(URLS.TENANTS + `?selectedOption=${TenantStatusesEnum.Current}&filterKey=Moving Out&filterLabel=Moving Out`)

        }
    ]

    const maintainence = [
        {
            id: 0,
            heading: maintainenceData?.openServiceRequests || 0,
            sub_Data: "Open Service Request",
            image: GetImages.ListBlue,
            onclick: () => navigate(URLS.SERVICE_REQUESTS + `?selectedOption=${"New"}`)

        },
        {
            id: 1,
            heading: maintainenceData?.inProgressServiceRequests || 0,
            sub_Data: "In Progress",
            image: GetImages.BlueProgress,
            onclick: () => navigate(URLS.SERVICE_REQUESTS + `?selectedOption=${"In Progress"}`)

        },
        {
            id: 2,
            heading: maintainenceData?.completedServiceRequests || 0,
            sub_Data: "Completed",
            image: GetImages.TickBlue,
            onclick: () => navigate(URLS.SERVICE_REQUESTS + `?selectedOption=${"Completed"}`)

        },
    ]

    const payments = [
        {
            id: 0,
            heading: `${paymentsData?.formatted?.OutstandingPayables || 0}`,
            raw: paymentsData?.formatted?.OutstandingPayablesRaw || 0,
            sub_Data: "Total Outstanding Payables",
            image: BluePayableIcon,
            onclick: () => navigate(URLS.PAYMENT + `?paymentMode=${"Payables"}&paidFlowTypeId=${PaidFlowTypesEnum.Payable}`)

        },
        {
            id: 1,
            heading: `${paymentsData?.formatted?.OverduePayables || 0}`,
            raw: paymentsData?.formatted?.OverduePayablesRaw || 0,
            sub_Data: "Overdue Payables",
            image: BluePayableIcon,
            onclick: () => navigate(URLS.PAYMENT + `?paymentMode=${"Payables"}&paidFlowTypeId=${PaidFlowTypesEnum.Payable}`)

        },
        {
            id: 2,
            heading: `${paymentsData?.formatted?.OutstandingReceivables || 0}`,
            raw: paymentsData?.formatted?.OutstandingReceivablesRaw || 0,
            sub_Data: "Total Outstanding Receivables",
            image: BluePayableIcon,
            onclick: () => navigate(URLS.PAYMENT + `?paymentMode=${"Receivables"}&paidFlowTypeId=${PaidFlowTypesEnum.Receiveable}`)

        },
        {
            id: 3,
            heading: `${paymentsData?.formatted?.OverdueReceivables || 0}`,
            raw: paymentsData?.formatted?.OverdueReceivablesRaw || 0,
            sub_Data: "Overdue Receivables",
            image: BluePayableIcon,
            onclick: () => navigate(URLS.PAYMENT + `?paymentMode=${"Receivables"}&paidFlowTypeId=${PaidFlowTypesEnum.Receiveable}`)

        },
    ]

    const customMonthField = "monthYear";
    const organization_id = Number(sessionStorage.getItem(UserLoginData.organization_id));
    const [fin_monthValue, setFin_MonthValue] = useState(-12);
    const { expensebycategoryArr, loading: dataLoading } = useAnalyticsHook({
        httpExpensebycategoryFn: AnalyticsService.getApiAnalyticsOrganizationExpensebycategory,
        customMonthField,
        parentEntityId: organization_id,
        fullyQualifiedFilters: {
            fin: `Created>DateTime.UtcNow.AddMonths(${fin_monthValue})`,
        },
    });

    const getTenantRetention = () => {
        setRetentionLoading(true);
        const payload = {
            dateFilterTypeId: timeRangeToEnumMap(rev_monthValue),
            clientDate: DateHelper.getClientDate(),
        };
        apiHelper(UserDashboardService.putApiUserDashboardTenantRetention, { showNotification: false }, orgId, payload)
            .then((res) => {
                if (res?.data?.success) {
                    setRetentionData(res?.data?.success);
                }
                setRetentionLoading(false);
            }).catch((err) => { setRetentionLoading(false); })
    }

    useEffect(() => {
        getTenantRetention()
    }, [rev_monthValue])


    const getServiceRequest = () => {
        setExpenseLoading(true);
        const payload = {
            // dateFilterTypeId: Number(cat_monthValue),
            dateFilterTypeId: timeRangeToEnumMap(cat_monthValue),
            clientDate: DateHelper.getClientDate(),
        };

        apiHelper(
            UserDashboardService.putApiUserDashboardServicerequestByType,
            { showNotification: false },
            orgId,
            payload
        )
            .then((res) => {
                const rawItems = res?.data?.success;

                if (Array.isArray(rawItems) && rawItems.length > 0) {
                    const colorPalette = [
                        "#057A55", // Emerald
                        "#FF5A1F", // Blue
                        "#D61F69", // Orange
                        "#1A56DB", // Green
                        "#db2777", // Pink
                       
                    ];

                    const formattedExpenseCategories = rawItems.map((item, index) => {
                        return {
                            name: item.formatted?.ServiceRequestType || "Unknown",
                            amount: Number(item.count), // Not `amount`
                            color: colorPalette[index % colorPalette.length],
                        };
                    });

                    setCategoryData(formattedExpenseCategories);
                } else {
                    setCategoryData([]);
                }
                setExpenseLoading(false);
            })
            .catch((err) => {
                console.error("Service Request API Error:", err);
                setCategoryData([]);
                setExpenseLoading(false);
            });
    };


    useEffect(() => {
        getServiceRequest()
    }, [cat_monthValue])


    return (
        <>
            {loading && (
                <div className="loading-container">
                    <SimpleSpinner myClassName={"Icon50"} />
                </div>
            )}
            <div id="dashboardMainContainer" style={{ display: loading == true && "none" }}>
                <div className="dashboardTopBar">
                    <p className="top_header">Welcome, {userinfo}</p>
                </div>
                <div className="dashboardDataContainer">
                    <div className='dashboard-top-section'>
                        <p className="heading black">Leasing</p>
                        <div className='dashboard-top-section-content'>
                            <div className='dashboard-left'>
                                <div className='leasing-grid'>
                                    {leasing?.map((item) => {
                                        return (
                                            <CardContainer
                                                key={item?.id}
                                                heading={item?.heading}
                                                sub_data={item?.sub_Data}
                                                image={item?.image} onClick={item?.onclick} 
                                                isLoading={leasingLoading}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="dashboard-right">
                                {/* <TenantsRetentionOverview loadingStates={loadingStates} setLoadingStates={setLoadingStates} /> */}
                                {/* <RevenueOverview
                                    data={data}
                                    {...sampleData}
                                    setRev_MonthValue={setRev_MonthValue}
                                    heading={"Tenants Retention Overview"}
                                /> */}

                                <DonutChart
                                    totalName="Retention Rate"
                                    heading="Tenants Retention Overview"
                                    formatAmount={false}
                                    data={[
                                        {
                                            title: "Retained",
                                            value: retentionData?.retainedTenants || 0,
                                            valueRaw: retentionData?.formatted?.RetainedTenantsRaw,
                                            formattedValue: retentionData?.formatted?.RetainedTenants,
                                            color: "#1A56DB",
                                        },
                                        {
                                            title: "Moved Out",
                                            value: retentionData?.movedOutTenants || 0,
                                            valueRaw: retentionData?.formatted?.MovedOutTenantsRaw,
                                            formattedValue: retentionData?.formatted?.MovedOutTenants,
                                            color: "#C3DDFD",
                                        },
                                    ]}
                                    valueTotal={retentionData?.formatted?.RetentionRate || "0"}
                                    symbolPosition="after"
                                    valueSymbol="%"
                                    isAlertStrip={false}
                                    onTimeRangeChange={setRev_MonthValue}
                                    isLoading={retentionLoading}
                                    isCurrency={false}
                                />

                            </div>
                        </div>
                    </div>
                    <div className='dashboard-middle-section'>
                        <p className="heading black">Maintenance</p>
                        <div className='middle-section'>
                            <div className='dashboard-left'>
                                {maintainence?.map((item) => {
                                    return (<CardContainer key={item?.id} heading={item?.heading} sub_data={item?.sub_Data} image={item?.image} onClick={item?.onclick} isLoading={maintenanceLoading} />
                                    )
                                })}
                            </div>
                            <div className='dashboard-right'>
                                <ExpenseDistribution
                                 showTotalAmountLabel={true} 
                                 defaultTimeRange={cat_monthValue}  
                                 setCat_MonthValue={setCat_MonthValue}
                                 heading="Service Request Categories Distribution"
                                 categories={categoryData} 
                                 showCurrencySymbol={false}
                                 isLoading={expenseLoading}
                                 />
                            </div>
                        </div>

                    </div>
                    <div className='dashboard-bottom-section'>
                        <p className="heading black">Payment</p>
                        <div className='bottom-card'>
                            <div className="dashboard-left">
                                {payments?.map((item) => {
                                    return (
                                        <CardContainer
                                            key={item?.id}
                                            heading={item?.heading}
                                            sub_data={item?.sub_Data}
                                            image={item?.image}
                                            onClick={item?.onclick}
                                            currency={true}
                                            raw={item?.raw}
                                            isLoading={paymentsLoading}
                                        />
                                    )
                                })}
                            </div>
                            <div className="dashboard-right">
                                <IncomeExpense incomeExpense_monthValue={incomeExpense_monthValue} setincomeExpense_MonthValue={setincomeExpense_MonthValue} loadingStates={loadingStates} setLoadingStates={setLoadingStates} />
                            </div>

                        </div>

                    </div>
                </div>

            </div></>
    )
}

export default Dashboard
